var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.123 504.123",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -57.9273,
    y1: 601.4416,
    x2: 63.1927,
    y2: 570.0586,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 364.0537 4969.6836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    style: {
      stopColor: "#E0B386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#DA498C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#961484"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M0,348.863c0,0,93.444-98.816,235.339-43.804c170.417,66.111,213.827,39.03,268.784-11.154 c0,0-62.527,130.615-244.894,63.724C64.614,286.249,0,348.863,0,348.863z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.182,
    y1: 585.8056,
    x2: 9.512,
    y2: 569.8256,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 364.0537 4969.6836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29D3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#0077FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#064093"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#084698"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M0,414.761c0,0,47.6-50.334,119.879-22.307c86.812,33.658,108.906,19.873,136.909-5.687 c0,0-31.846,66.528-124.739,32.461C32.91,382.867,0,414.761,0,414.761z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1248,
    y1: 602.2856,
    x2: 23.8722,
    y2: 600.2156,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 364.0537 4969.6836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29D3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#0077FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#064093"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#084698"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M433.373,297.592c-5.616-1.111-55.65-13.17-54.493-88.954 c0.205-13.391,1.52-24.505,3.49-35.698c-36.005-16.88-63.141-11.461-63.37-11.461h-0.016l0,0h-0.032l0.032-1 c-0.055,0.323-9.003,53.973,46.371,111.072c27.687,28.554,52.382,30.09,67.994,26.813 C433.357,298.19,433.365,297.765,433.373,297.592z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8997,
    y1: 628.8096,
    x2: 2.5997,
    y2: 587.7266,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 364.0537 4969.6836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    style: {
      stopColor: "#E0B386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#DA498C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#961484"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M437.169,75.21v-0.024V75.21v-0.024V75.21c0,0.197-41.173,28.538-53.201,96.705 c14.966,7.034,30.649,17.629,47.419,33.894c44.355,43.008,23.773,79.029,20.212,84.582c0.039,0.158-0.126,0.307-0.079,0.465 c16.455-9.476,40.023-31.547,39.243-82.219C489.307,113.642,437.169,75.439,437.169,75.21z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.574f4d948c5e133f0695bd3fd6815710.svg";
export { ForwardRef as ReactComponent };